import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { useCountryContext } from '../../context'
import config from './config'
import '@scentregroup/ui/fonts/index.css'
import '@scentregroup/ui/tools/reset.css'

const TemplateWrapper = ({ children }) => {
  const META_INFORMATION =
    useCountryContext() === 'New Zealand' ? config.nz : config.au
  return (
    <Fragment>
      <Helmet
        defaultTitle={META_INFORMATION.title}
        meta={META_INFORMATION.meta}
      >
        <html lang={META_INFORMATION.lang} />
        <meta name="description" content={META_INFORMATION.meta.content} />
      </Helmet>
      {children}
    </Fragment>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.node,
}

export default TemplateWrapper
